const ROOM_QUERY_KEYS = ["room", "invite", "token", "match"] as const;

/** Navigate the whole online session, so its cookie and WebSocket stay same-origin. */
export function puzzleMultiplayerDestination(
  currentHref: string,
  configuredOrigin: string | undefined,
  createRoom = false,
): string | null {
  if (!configuredOrigin?.trim()) return null;
  const current = new URL(currentHref);
  const destination = new URL(configuredOrigin);
  if (destination.protocol !== "https:" || destination.username || destination.password
    || destination.pathname !== "/" || destination.search || destination.hash) {
    throw new Error("멀티플레이 서버 주소 설정이 올바르지 않습니다.");
  }
  if (destination.origin === current.origin) return null;

  if (createRoom) {
    destination.searchParams.set("multiplayer", "create");
  } else {
    // Never forward arbitrary query parameters, credentials, or a return URL.
    for (const key of ROOM_QUERY_KEYS) {
      const value = current.searchParams.get(key);
      if (value) destination.searchParams.set(key, value);
    }
    if (current.searchParams.get("multiplayer") === "create") {
      destination.searchParams.set("multiplayer", "create");
    }
    if (!destination.search) return null;
  }
  return destination.href;
}
